module.exports = __webpack_public_path__ + "static/lframe-financial-hardship-de3004c803b14db824adf05986fc6632.png";